import React, { FunctionComponent, ReactNode, HTMLAttributes } from 'react';
import classNames from 'classnames';
import styles from './Strong.module.scss';

export type Props = {
  text?: string;
  className?: string;
  children?: ReactNode;
} & HTMLAttributes<any>;

export const Strong: FunctionComponent<Props> = ({
  text,
  className,
  children,
  ...rest
}) => {
  return (
    <strong className={classNames(styles.Strong, className)} {...rest}>
      {text}
      {children}
    </strong>
  );
};
